import { Box, Text } from '@frontend/legacy-components';

import HighlightOrDisplay from './HighlightOrDisplay';

const TextMatches = ({
  category,
  fsHide,
  results,
  field,
  allowNestedLink,
  showOnlyIfHighlighted,
  resultOwnerId,
}) => {
  const innerResults = showOnlyIfHighlighted
    ? results.filter((res) => res.highlight?.[field] ?? false)
    : results;

  if (innerResults.length === 0) {
    return null;
  }
  return (
    <Box>
      <Text
        textTransform="uppercase"
        fontSize="sm"
        fontWeight="heavy"
        color="feature.secondary"
      >
        {category}
      </Text>
      {innerResults.map((result, index) => (
        <>
          <HighlightOrDisplay
            key={index}
            allowNestedLink={allowNestedLink}
            field={field}
            result={result}
            resultOwnerId={resultOwnerId}
            showOnlyIfHighlighted={showOnlyIfHighlighted}
            {...(fsHide ? { 'data-fs-hide': 'true' } : null)}
          />
          <br />
        </>
      ))}
    </Box>
  );
};

export default TextMatches;
